import { render, staticRenderFns } from "./BestAvailableOffer.vue?vue&type=template&id=2c7878ee&"
import script from "./BestAvailableOffer.vue?vue&type=script&setup=true&lang=js&"
export * from "./BestAvailableOffer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports